import React from 'react'
import CreateEditProjectForm from '../components/Projects/CreateEditProjectForm'
const CreateProject = () => {
    return <CreateEditProjectForm mode={'add'} />
}

export { CreateProject }